import { Component, EventEmitter, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ITable } from "src/app/models/ITable";

@Component({
    selector: 'app-table-ordentaller-componentes',
    templateUrl: './../../../../../shared/tables/table.component.html',
    styleUrls: [ './../../Styles/ordenDeTaller.component.scss' ],
    encapsulation: ViewEncapsulation.None
})
// 2021-08-12 (aaangeles) Creacion
export class TableOrdenDeTallerDetalle implements ITable {
    @Output() RowToEdit = new EventEmitter();
    @Output() RowToCell = new EventEmitter();
    @Output() RowToDelete = new EventEmitter();
    displayedColumns        = [];
    displaycolumnsDef       = [];
    displayToasta           : boolean = false;
    dataSource              : any = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort    : MatSort;
    Paginado                    : boolean = true;
    tblEditClass                : string;
    tblDataClass                : string;
    search                      : any;
    disable                     : any;
    objectKeys                  : (option: any) => any;
    UpdateScroll                : () => void;
    GetImpresion                : (row: any) => any;
    GetSelected                 : (row: any) => any;
    GetOpen                     : (row: any) => any;
    Confirm                     : (row: any) => any;
    BrokenImage                 : (event: any, row: any) => any;
    masterToggle                : () => any;
    isAllSelected               : () => boolean;
    ListModelChange             : (row: any, event: any, colDef: any) => any;
    CheckboxModelChanged        : (row: any, event: any, colDef: any) => any;
    selection                   : { hasValue: () => any; toggle: (row : any) => any; isSelected: (row: any) => any; };
	GetCellRow: (col: any, newValue: any, oldValue: any, editRowModel: any) => any;
    GetTime: (event: any, celda: any, colDef: any) => any;

    constructor() { }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<any>([]);
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        })
    }
    SetColumnDefs(colDefs: any[]) {
        this.displaycolumnsDef = colDefs;
        this.displayedColumns = colDefs.map(c => c.columnDef);
    }
    SetData(dataSource: any[]) {
        this.dataSource = new MatTableDataSource<any>(dataSource);
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        })
        this.paginator.pageSize = 20;
        this.dataSource.paginator = this.paginator;
    }
    GetEditar(row) {
        this.RowToEdit.emit(row)
    }
    GetElimina(row) {
        this.RowToDelete.emit(row);
    }
    SelectedByClick(row) {
    }
    GetRowClass(row: any) {
        let classAsigned = '';
        // Condicion para agregar la clase
        return classAsigned;
    }
    public EventChange(data: any) {
        switch (data.col) {
            case 'componente':
            case 'descripcion':
            case 'programado':
            case 'sistema':
            default: break;
        }
    }
}
